import { useContext } from "react";
import { AuthContext } from "../../../util/context";
import LeaveDetail from "../../leave/leave -detail/LeaveDetail";
import Login from "../../auth/Login";
import { getStoredItem } from "../../../util/lib";
import Dashboard from "../../dashboard/Dashboard";

export default function LeaveDetailPage() {
  let view;
  const { isAuthenticated } = useContext(AuthContext);
  const userType = getStoredItem("user-type");

  if (userType === "employee") {
    view = <LeaveDetail />;
  } else {
    view = <Dashboard />;
  }
  return <>{isAuthenticated ? view : <Login />}</>;
}
